import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapPlaceComponent } from './map-place.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
//import { PlatformModule } from '@angular/cdk/platform';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { HammerGestureConfig } from '@angular/platform-browser';
import { SpinnerModule } from '../spinner/spinner.module';
//import "hammerjs";
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

@NgModule({
  declarations: [MapPlaceComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    NgSelectModule,
    SpinnerModule,
  //  PlatformModule,
  //  BrowserAnimationsModule
  ],
  exports: [MapPlaceComponent],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig }
  ]
})
export class MapPlaceModule { }
